import React from 'react'
import PropTypes from 'prop-types'
import { Stack, Typography, Grid } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import rem from 'utils/rem'

const ConfirmationScreen = ({ title, subtitle, ActionButtonList, Icon }) => (
  <Grid container flexDirection="column" justifyContent="center" alignItems="center" sx={{ height: '100vh' }}>
    <Grid container justifyContent="center" alignItems="center">
      <Grid item mr={2} justifyContent="center" alignItems="center" sx={{ display: 'flex' }}>
        <Icon color="primary" sx={{ fontSize: rem(35) }} />
      </Grid>

      <Grid item>
        <Typography variant="h4">{title}</Typography>
      </Grid>
    </Grid>

    <Typography mt={rem(40)} variant="h5">
      {subtitle}
    </Typography>

    <Stack direction="column" mt={rem(24)} spacing={rem(16)}>
      <ActionButtonList />
    </Stack>
  </Grid>
)

ConfirmationScreen.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  ActionButtonList: PropTypes.elementType.isRequired,
  Icon: PropTypes.elementType,
}

ConfirmationScreen.defaultProps = {
  Icon: CheckCircleIcon,
  subtitle: 'What would you like to do next?',
}

export default ConfirmationScreen
